var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaterPump24Dp5F6368Fill0Wght400Grad0Opsz24 = function SvgWaterPump24Dp5F6368Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#5f6368",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-280h164q-17-17-31.5-37T227-360H120zm360 0q83 0 141.5-58.5T680-480t-58.5-141.5T480-680t-141.5 58.5T280-480t58.5 141.5T480-280m253-320h107v-80H676q17 17 31.5 37t25.5 43M40-160v-320h80v40h83q-2-10-2.5-19.5T200-480q0-117 81.5-198.5T480-760h360v-40h80v320h-80v-40h-83q2 10 2.5 19.5t.5 20.5q0 117-81.5 198.5T480-200H120v40zm80-120v-80zm720-320v-80zM480-360q-33 0-56.5-23.5T400-440q0-23 9.5-45.5T446-550l34-50 34 50q27 42 36.5 64.5T560-440q0 33-23.5 56.5T480-360"
  })));
};
export default SvgWaterPump24Dp5F6368Fill0Wght400Grad0Opsz24;